import Button from 'molecules/Button';

import ResourceCard from 'layout/Listing/components/ResourceCard';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

export interface ResourceSectionProps {
  label: string;
  link: string;
  posts: { data: Resources }[];
  labelBuilder?: string;
}

const ResourceSection: FC<ResourceSectionProps> = ({ label, link, posts, labelBuilder }) => (
  <div className="flex flex-col gap-6">
    <div className="flex items-center justify-between gap-6 border-b border-gray-300 pb-4 dark:border-gray-700">
      {labelBuilder && (
        <h2 className="font-spaceGrotesk text-display-xs font-bold text-gray-900 dark:text-white">{labelBuilder}</h2>
      )}
      <Button
        label="View All"
        href={link}
        endIcon="arrow-right"
        hierarchy="linkGray"
        aria-label={`View All ${label} Posts`}
      />
    </div>

    {hasArrayValues(posts) && (
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map(post => (
          <ResourceCard key={post.data.url} {...post.data} isDarkGradient={true} />
        ))}
      </div>
    )}
  </div>
);

export default ResourceSection;
